import { render, staticRenderFns } from "./SubcatItem.vue?vue&type=template&id=f62db416&scoped=true&"
import script from "./SubcatItem.vue?vue&type=script&lang=js&"
export * from "./SubcatItem.vue?vue&type=script&lang=js&"
import style0 from "./SubcatItem.vue?vue&type=style&index=0&id=f62db416&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f62db416",
  null
  
)

export default component.exports